import { TranslateMessageFormatCompiler } from 'ngx-translate-messageformat-compiler';
import { Injectable } from '@angular/core';

import { CommonAppDataService } from '../app_data/app_data.service';
import {
	ICommonLocaleServiceTranslations,
	TCommonLocaleServiceCompilerResult,
} from './locale.service';

@Injectable()
export class CommonTranslationCompiler {
	readonly locale: string = this.commonAppDataService.getDataByPath('locale');

	constructor (
		private messageFormat: TranslateMessageFormatCompiler,
		private commonAppDataService: CommonAppDataService,
	) {}

	compile (value: string): string {
		return value;
	}

	compileTranslations (translations: ICommonLocaleServiceTranslations): ICommonLocaleServiceTranslations {
		for (const key in translations) {
			if (translations.hasOwnProperty(key)) {
				translations[key] = this.resolveReferences(translations[key], translations);
			}
		}
		return translations;
	}

	private resolveReferences (
		value: TCommonLocaleServiceCompilerResult,
		translations: ICommonLocaleServiceTranslations,
	): TCommonLocaleServiceCompilerResult {
		if ((value as string).match('plural,') || (value as string).match('select,')) {
			return this.messageFormat.compile(value as string, this.locale);
		}

		return (value as string).replace(/@:(\S+)/, (
			matches,
			key,
		) => this.resolveReferences(translations[key], translations) as string);
	}
}
